/** RevenueCat / App Store Connect identifiers (configured in RevenueCat dashboard). */
export const REVENUECAT_ENTITLEMENT_PACK_LEADER = 'pack_leader'
export const REVENUECAT_OFFERING_IDENTIFIER = 'default'
export const REVENUECAT_PACKAGE_IDENTIFIER = '$rc_monthly'
export const APPLE_PRODUCT_ID_PACK_LEADER = 'com.wagamour.packleader.monthly'

/** Request header sent from native iOS upgrade flows (Stripe checkout guard). */
export const WAGAMOUR_PLATFORM_HEADER = 'X-Wagamour-Platform'
export const WAGAMOUR_PLATFORM_IOS_NATIVE = 'ios-native'

/** Synthetic Subscription.stripeSubscriptionId prefix for RevenueCat-backed rows (no schema migration). */
export const REVENUECAT_SUBSCRIPTION_ID_PREFIX = 'revenuecat:'

/** User-visible copy when subscription verification/sync is pending or failed. */
export const SUBSCRIPTION_STATUS_UPDATING_USER_MESSAGE =
  'Subscription status is updating. Please try again in a moment.'

export const SUBSCRIPTION_PURCHASE_COMPLETED_REFRESHING_MESSAGE =
  "Purchase completed. We're refreshing your access."

export const SUBSCRIPTION_PURCHASE_UNAVAILABLE_USER_MESSAGE =
  'Unable to start purchase. Please try again in a moment.'

export const SUBSCRIPTION_PURCHASE_FAILED_USER_MESSAGE =
  'Unable to complete purchase. Please try again in a moment.'

export const SUBSCRIPTION_RESTORE_FAILED_USER_MESSAGE =
  'Unable to restore purchases. Please try again in a moment.'

export const SUBSCRIPTION_OPTIONS_LOADING_LABEL =
  'Loading subscription options...'

const PAYWALL_BLOCKED_UI_TERMS =
  /revenuecat|verify(?:ing|ication)?|entitlement|receipt|storekit|json/i

export function isSubscriptionVerificationUserMessage(
  message: string
): boolean {
  return message.trim() === SUBSCRIPTION_STATUS_UPDATING_USER_MESSAGE
}

/** Strip vendor/infrastructure terms from paywall UI; keep logs server-side. */
export function sanitizePaywallUserMessage(
  message: string | null | undefined,
  kind:
    | 'purchase_prep'
    | 'purchase_failed'
    | 'purchase_verify'
    | 'restore_failed'
    | 'restore_verify'
): string {
  if (kind === 'purchase_verify' || kind === 'restore_verify') {
    return SUBSCRIPTION_STATUS_UPDATING_USER_MESSAGE
  }
  if (kind === 'purchase_prep') {
    return SUBSCRIPTION_PURCHASE_UNAVAILABLE_USER_MESSAGE
  }
  const fallback =
    kind === 'restore_failed'
      ? SUBSCRIPTION_RESTORE_FAILED_USER_MESSAGE
      : SUBSCRIPTION_PURCHASE_FAILED_USER_MESSAGE
  if (!message?.trim()) return fallback
  if (/could not verify subscription/i.test(message)) {
    return SUBSCRIPTION_PURCHASE_COMPLETED_REFRESHING_MESSAGE
  }
  if (PAYWALL_BLOCKED_UI_TERMS.test(message)) {
    return fallback
  }
  return message.trim()
}
